import React, {useEffect, useState} from "react"
import {Container, Header} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization, interpolateString} from "../utils/localization";
import {connect, useDispatch} from "react-redux";
import Footer from "./footer";
import GetHelpModal from "./getHelpModal";
import {ClickableText, CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";
import useLockNavigation from "../hooks/useLockNavigation";
import {setEnrollmentDeclined} from "../actions/initialDataActions";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        ...ownProps,
        name: user.firstName,
        lang: user.lang,
        initialData, benAdmin,
        user,
    }
};

const ThanksDeclined  = ({name, lang, initialData}) => {
    const [displayGetHelpModal, setDisplayGetHelpModal] = useState(false);
    const localization = getLocalization(lang);
    const strings = localization.thanksDeclined;
    const dispatch = useDispatch();
    useLockNavigation();

    useEffect(() => {
        if(!initialData.enrollmentDeclined) {
            dispatch(setEnrollmentDeclined(true));
        }
    },[dispatch, initialData.enrollmentDeclined])

    return (
        <React.Fragment>
            <Container className={'contentContainer'}>

                <GetHelpModal localization={localization} uiFlow={initialData.uiFlow}
                                employerId={!!initialData && !!initialData.employer && initialData.employer.id}
                                displayCoveredModal={displayGetHelpModal}
                                onModalClose={() => setDisplayGetHelpModal(false)}
                />

                <CustomGrid container stackable columns={1} centered fitted={'horizontally'}>
                    <CustomGrid.Column width={8}>
                        <CustomGrid stackable container style={{marginTop: '5em'}}>
                            <CustomGrid.Row columns={1}>
                                <CustomGrid.Column textAlign={"center"}>
                                    <S3Image {...IMAGE.CHECK}/>
                                    <Header as='h1'>{interpolateString(strings.thankYou, [name])}</Header>
                                    <p>
                                        {strings.youHaveSuccessfully}<br/>
                                        {strings.toMakeAChange}
                                        <ClickableText onClick={() => setDisplayGetHelpModal(true)}>
                                            {strings.contactOurConcierge}
                                        </ClickableText>
                                    </p>
                                </CustomGrid.Column>
                            </CustomGrid.Row>
                        </CustomGrid>
                    </CustomGrid.Column>
                </CustomGrid>
            </Container>
            <Footer showTopFooter={false} showCenterData={true}/>
        </React.Fragment>
        )
    }

export default withRouter(connect(mapStateToProps)(ThanksDeclined));
